export enum WorkflowStatus {
  DRAFT,
  PUBLISHED,
  PAUSED,
  UNPUBLISHED,
}
